import React from 'react';
import AdminReportViewer from '../../../sections/AdminDashboard/Reports/AdminReportViewer';

const AdminReportDetail = () => <AdminReportViewer />;

export default AdminReportDetail;
